import { type RouteRecordRaw } from 'vue-router'

// Use dynamic import method to load components (it reduces the bundle during build time)
// To use dynamic import each component must be called by () => import('path_of_the_component.vue')
const LegacyView = () => import('@/common/views/LegacyView.vue')
const BaseHeader = () => import('@/agent/components/headers/BaseHeader.vue')
const DefaultView = () => import('@/common/views/DefaultView.vue')

const ParkPage = () => import('@/common/views/park/ParkPage.vue')
const LoginToParkPage = () => import('@/common/views/park/LoginToParkPage.vue')
import useNavigation from '@/common/composables/useNavigation'
const LogoutPage = () => import('@/common/views/LogoutPage.vue')
const ErrorPage = () => import('@/common/views/ErrorPage.vue')

import adminRoutes from '@/admin/router/routes'
import agentRoutes from '@/agent/routes'
import engageRoutes from '@/engage/routes'
import { changePasswordRouteBeforeEnter } from '@/router/guards'
import { clearLocalStorageBeforeEnter, landingPageBeforeEnter } from '@/router/authentication'
import { APP_ROUTE_NAMES } from '@/app/types/router'

const navigation = useNavigation()

export const routes: Array<RouteRecordRaw> = [
  ...adminRoutes,
  ...agentRoutes,
  ...engageRoutes,
  {
    path: '/assist/login',
    component: {},
    beforeEnter: (to) => {
      navigation.redirectToLegacy(to.fullPath.replace('/assist/', ''))
    },
  },
  {
    path: '/assist/logout',
    component: {},
    beforeEnter: (to) => {
      navigation.redirectToLegacy(to.fullPath.replace('/assist/', ''))
    },
  },
  {
    path: '/assist/changePassword',
    component: LegacyView,
    beforeEnter: changePasswordRouteBeforeEnter,
    children: [
      {
        path: '',
        component: BaseHeader,
        props: {
          menu: false,
        },
      },
    ],
    meta: {
      legacy: true,
    },
  },
  {
    path: '/assist/auth-guard',
    component: () => undefined,
    beforeEnter: [clearLocalStorageBeforeEnter, landingPageBeforeEnter],
  },
  {
    path: '/assist/park-page',
    name: 'park-page',
    component: ParkPage,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/assist/login-to-park-page',
    name: 'login-to-park-page',
    component: LoginToParkPage,
    meta: {
      requiresSession: false,
    },
  },
  {
    path: '/assist/error',
    name: APP_ROUTE_NAMES.ERROR_ROUTE_NAME,
    component: ErrorPage,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/assist/oidc-logout',
    name: APP_ROUTE_NAMES.OIDC_LOGOUT_ROUTE_NAME,
    component: LogoutPage,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/assist/:url+',
    component: DefaultView,
    props: {
      menu: true,
    },
    meta: {
      legacy: true,
    },
  },
]
